import { useEffect, useRef } from 'react'

type PlaceSelectResultsChangeHandler = (
  results: Array<App.SearchItem>,
  searchPhrase: string,
  shouldTrack?: boolean,
  loading?: boolean,
) => void

function usePlaceSelectResultsChange(
  results: Array<App.SearchItem>,
  searchPhrase: string,
  loading: boolean,
  onResultsChange: PlaceSelectResultsChangeHandler,
) {
  const onResultsChangeRef = useRef(onResultsChange)
  // A new callback identity must not notify again for unchanged results.
  onResultsChangeRef.current = onResultsChange

  const prevLoadingRef = useRef(loading)
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    hasTrackedRef.current = false
  }, [searchPhrase])

  useEffect(() => {
    const shouldTrack = prevLoadingRef.current && !loading && !hasTrackedRef.current
    if (shouldTrack) {
      hasTrackedRef.current = true
    }
    onResultsChangeRef.current(results, searchPhrase, shouldTrack, loading)
    prevLoadingRef.current = loading
  }, [results, loading, searchPhrase])
}

export default usePlaceSelectResultsChange
